import { render, staticRenderFns } from "./ProjectAssignmentsPage.vue?vue&type=template&id=a0943b58&scoped=true"
import script from "./ProjectAssignmentsPage.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentsPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignmentsPage.vue?vue&type=style&index=0&id=a0943b58&prod&lang=scss"
import style1 from "./ProjectAssignmentsPage.vue?vue&type=style&index=1&id=a0943b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0943b58",
  null
  
)

export default component.exports